import styled from 'styled-components';

import { Stack } from '@components/stack';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type HeaderProps = {
  actions?: JSX.Element;
  breadcrumbs?: JSX.Element;
  tabs?: JSX.Element;
  backAction?: JSX.Element;
  title?: JSX.Element;
  selectionHeader?: JSX.Element;
  showSelectionHeader?: boolean;
  hideTabs?: boolean;
};

export const Header = ({
  actions,
  breadcrumbs,
  tabs,
  backAction,
  title,
  selectionHeader,
  showSelectionHeader = false,
  hideTabs = false,
}: HeaderProps) => {
  return (
    <Container hasTabs={Boolean(tabs) && !hideTabs} isSelection={showSelectionHeader} id="header">
      {showSelectionHeader ? (
        selectionHeader
      ) : (
        <>
          <InnerContainer>
            <Stack space={2} orientation="horizontal" align="center">
              {backAction}
              {title ?? <Breadcrumbs>{breadcrumbs}</Breadcrumbs>}
            </Stack>
            {tabs && !hideTabs && <TabsContainer>{tabs}</TabsContainer>}
          </InnerContainer>
          <HeaderActions id="header-actions">{actions}</HeaderActions>
        </>
      )}
    </Container>
  );
};

const HeaderHeightWithTabs = '7.5rem';
export const HeaderHeightDefault = '5.5rem';

const Container = styled.div<{ hasTabs: boolean; isSelection: boolean }>(
  ({ hasTabs, isSelection }) => ({
    display: 'flex',
    padding: '1.5rem 1.5rem 0 1.5rem',
    transition: 'min-height 0.2s ease-out',
    justifyContent: 'space-between',
    minHeight: hasTabs ? HeaderHeightWithTabs : HeaderHeightDefault,
    backgroundColor: isSelection
      ? theme.color.backgroundSecondary
      : theme.color.backgroundLightDark,
    borderBottom: `${pxToRem(1)} solid ${
      isSelection ? theme.color.uiTrans10 : theme.color.border10
    }`,
    zIndex: 10,
  })
);

const InnerContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const Breadcrumbs = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  height: '2.5rem',
});

const TabsContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
});

export const HeaderActions = styled.div({
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
  alignItems: 'flex-start',
});
